import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  ArrowLeft,
  ArrowRight,
  CheckCircle2,
  ClipboardList,
  LockKeyhole
} from "lucide-react";

import { etapas } from "../etapas";
import "../styles/PATINFormulario.css";


function Campo({ campo, valor, atualizar }) {
  const [id, pergunta, tipo, opcoes] = campo;

  if (tipo === "tabela_indicadores") {
    const colunas = [
      ["indicador", "Indicador"],
      ["situacao", "Situação atual"],
      ["meta", "Meta"],
      ["acompanhamento", "Como acompanhar"]
    ];

    let linhas = [];

    try {
      const dados = JSON.parse(valor || "[]");
      linhas = Array.isArray(dados) ? dados : [];
    } catch {
      linhas = [];
    }

    function alterarLinha(indice, coluna, texto) {
      const novas = linhas.map((linha) => ({ ...linha }));
      novas[indice][coluna] = texto;
      atualizar(id, JSON.stringify(novas));
    }

    function adicionarLinha() {
      if (linhas.length >= 5) return;

      atualizar(
        id,
        JSON.stringify([
          ...linhas,
          {
            indicador: "",
            situacao: "",
            meta: "",
            acompanhamento: ""
          }
        ])
      );
    }

    function removerLinha(indice) {
      atualizar(
        id,
        JSON.stringify(linhas.filter((_, i) => i !== indice))
      );
    }

    return (
      <div className="patin-form-campo">
        <h3>{pergunta}</h3>

        <p>Registre de 3 a 5 indicadores para acompanhar o negócio.</p>

        {linhas.map((linha, indice) => (
          <div
            key={indice}
            style={{
              border: "1px solid #ddd",
              borderRadius: 10,
              padding: 16,
              marginBottom: 16
            }}
          >
            <h4>Indicador {indice + 1}</h4>

            {colunas.map(([chave, titulo]) => (
              <label
                key={chave}
                style={{ display: "block", marginBottom: 12 }}
              >
                {titulo}

                <input
                  type="text"
                  value={linha[chave] || ""}
                  onChange={(e) =>
                    alterarLinha(indice, chave, e.target.value)
                  }
                />
              </label>
            ))}

            <button
              type="button"
              className="patin-form-anterior"
              onClick={() => removerLinha(indice)}
            >
              Remover indicador
            </button>
          </div>
        ))}

        <button
          type="button"
          className="patin-form-anterior"
          onClick={adicionarLinha}
          disabled={linhas.length >= 5}
        >
          + Adicionar indicador
        </button>
      </div>
    );
  }

  if (tipo === "tabela_transformacao") {
    const colunas = [
      ["area", "Área"],
      ["transformar", "O que transformar?"],
      ["fazer", "O que fazer?"],
      ["como", "Como fazer?"],
      ["prazo", "Prazo"],
      ["resultado", "Resultado esperado"]
    ];

    let linhas = [];

    try {
      const dados = JSON.parse(valor || "[]");
      linhas = Array.isArray(dados) ? dados : [];
    } catch {
      linhas = [];
    }

    function alterarLinha(indice, coluna, texto) {
      const novas = linhas.map((linha) => ({ ...linha }));
      novas[indice][coluna] = texto;
      atualizar(id, JSON.stringify(novas));
    }

    function adicionarLinha() {
      const nova = Object.fromEntries(
        colunas.map(([chave]) => [chave, ""])
      );

      atualizar(id, JSON.stringify([...linhas, nova]));
    }

    function removerLinha(indice) {
      atualizar(
        id,
        JSON.stringify(linhas.filter((_, i) => i !== indice))
      );
    }

    return (
      <div className="patin-form-campo">
        <h3>{pergunta}</h3>

        <p>
          Registre as transformações planejadas para o negócio.
          Você pode adicionar quantas ações precisar.
        </p>

        {linhas.map((linha, indice) => (
          <div
            key={indice}
            style={{
              border: "1px solid #ddd",
              borderRadius: 10,
              padding: 16,
              marginBottom: 16
            }}
          >
            <h4>Ação {indice + 1}</h4>

            {colunas.map(([chave, titulo]) => (
              <label
                key={chave}
                style={{
                  display: "block",
                  marginBottom: 12
                }}
              >
                {titulo}

                <textarea
                  value={linha[chave] || ""}
                  rows={2}
                  onChange={(e) =>
                    alterarLinha(indice, chave, e.target.value)
                  }
                />
              </label>
            ))}

            <button
              type="button"
              className="patin-form-anterior"
              onClick={() => removerLinha(indice)}
            >
              Remover ação
            </button>
          </div>
        ))}

        <button
          type="button"
          className="patin-form-anterior"
          onClick={adicionarLinha}
        >
          + Adicionar ação ao plano
        </button>
      </div>
    );
  }

  if (tipo === "tabela_produtos") {
    let linhas = [];

    try {
      const dados = JSON.parse(valor || "[]");
      linhas = Array.isArray(dados) ? dados : [];
    } catch {
      linhas = [];
    }

    function alterarLinha(indice, coluna, texto) {
      const novas = linhas.map((linha) => ({ ...linha }));
      novas[indice][coluna] = texto;
      atualizar(id, JSON.stringify(novas));
    }

    function adicionarLinha() {
      atualizar(
        id,
        JSON.stringify([
          ...linhas,
          { produto: "", publico: "", melhoria: "" }
        ])
      );
    }

    function removerLinha(indice) {
      atualizar(
        id,
        JSON.stringify(linhas.filter((_, i) => i !== indice))
      );
    }

    return (
      <div className="patin-form-campo">
        <h3>{pergunta}</h3>

        {linhas.map((linha, indice) => (
          <div
            key={indice}
            style={{
              border: "1px solid #ddd",
              padding: 16,
              borderRadius: 10,
              marginBottom: 12
            }}
          >
            {[
              ["produto", "Produto ou serviço"],
              ["publico", "Para quem é?"],
              ["melhoria", "O que posso melhorar?"]
            ].map(([coluna, titulo]) => (
              <label
                key={coluna}
                style={{ display: "block", marginBottom: 10 }}
              >
                {titulo}
                <input
                  type="text"
                  value={linha[coluna] || ""}
                  onChange={(e) =>
                    alterarLinha(indice, coluna, e.target.value)
                  }
                />
              </label>
            ))}

            <button
              type="button"
              onClick={() => removerLinha(indice)}
              className="patin-form-anterior"
            >
              Remover produto
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={adicionarLinha}
          className="patin-form-anterior"
        >
          + Adicionar produto ou serviço
        </button>
      </div>
    );
  }

  if (tipo === "multipla") {
    const selecionadas = typeof valor === "string"
      ? valor.split(";").filter(Boolean)
      : [];

    function alternar(opcao) {
      const novas = selecionadas.includes(opcao)
        ? selecionadas.filter((item) => item !== opcao)
        : [...selecionadas, opcao];

      atualizar(id, novas.join(";"));
    }

    return (
      <fieldset className="patin-form-campo">
        <legend>{pergunta}</legend>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "12px",
            marginTop: "12px"
          }}
        >
          {opcoes.map((opcao) => (
            <label
              key={opcao}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                cursor: "pointer"
              }}
            >
              <input
                type="checkbox"
                checked={selecionadas.includes(opcao)}
                onChange={() => alternar(opcao)}
              />
              <span>{opcao}</span>
            </label>
          ))}
        </div>
      </fieldset>
    );
  }

  if (tipo === "escala") {
    return (
      <div className="patin-form-campo">
        <label>{pergunta}</label>

        <div className="patin-escala">
          {[1, 2, 3, 4, 5].map((nota) => (
            <button
              key={nota}
              type="button"
              className={valor === nota ? "selecionado" : ""}
              onClick={() => atualizar(id, nota)}
              aria-pressed={valor === nota}
            >
              {nota}
            </button>
          ))}
        </div>

        <div className="patin-escala-legenda">
          <span>1 — Preciso começar</span>
          <span>2 — Estou começando</span>
          <span>3 — Já faço</span>
          <span>4 — Faço bem</span>
          <span>5 — Consolidado</span>
        </div>
      </div>
    );
  }

  return (
    <div className="patin-form-campo">
      <label htmlFor={id}>{pergunta}</label>

      {tipo === "textarea" ? (
        <textarea
          id={id}
          value={valor || ""}
          onChange={(e) => atualizar(id, e.target.value)}
          rows={4}
          placeholder="Escreva sua resposta..."
        />
      ) : tipo === "select" ? (
        <select
          id={id}
          value={valor || ""}
          onChange={(e) => atualizar(id, e.target.value)}
        >
          <option value="">Selecione uma opção</option>
          {opcoes.map((opcao) => (
            <option key={opcao} value={opcao}>
              {opcao}
            </option>
          ))}
        </select>
      ) : (
        <input
          id={id}
          type={tipo}
          value={valor || ""}
          onChange={(e) => atualizar(id, e.target.value)}
          placeholder="Digite sua resposta..."
        />
      )}
    </div>
  );
}

export default function PATINFormulario() {
  const [etapa, setEtapa] = useState(0);
  const [respostas, setRespostas] = useState({});
  const [concluido, setConcluido] = useState(false);

  const { protocolo } = useParams();
  const navigate = useNavigate();
  const modoReal = Boolean(protocolo);

  const [carregando, setCarregando] = useState(modoReal);
  const [erro, setErro] = useState("");
  const [usuario, setUsuario] = useState(null);
  const [participante, setParticipante] = useState(null);

  useEffect(() => {
    if (!modoReal) return;

    let ativo = true;

    async function carregarDocumento() {
      try {
        const sessao = await fetch("/api/patin/auth/me", {
          credentials: "same-origin"
        });

        if (sessao.status === 401) {
          navigate("/patin/login", { replace: true });
          return;
        }

        if (!sessao.ok) {
          throw new Error("Não foi possível verificar sua sessão.");
        }

        const dadosUsuario = await sessao.json();

        const resposta = await fetch(
          `/api/patin/documento/${encodeURIComponent(protocolo)}`,
          { credentials: "same-origin" }
        );

        if (resposta.status === 401) {
          navigate("/patin/login", { replace: true });
          return;
        }

        if (!resposta.ok) {
          throw new Error("Você não tem acesso a este PATIN.");
        }

        const documento = await resposta.json();

        if (ativo) {
          setUsuario(dadosUsuario);
          setParticipante(documento.participante);
          setRespostas(documento.respostas || {});
        }
      } catch (e) {
        if (ativo) setErro(e.message);
      } finally {
        if (ativo) setCarregando(false);
      }
    }

    carregarDocumento();

    return () => {
      ativo = false;
    };
  }, [modoReal, protocolo, navigate]);


  const etapaAtual = etapas[etapa];
  const progresso = Math.round(
    ((etapa + 1) / etapas.length) * 100
  );

  const [estadoSalvamento, setEstadoSalvamento] = useState("");
  const pendentes = useRef({});
  const temporizador = useRef(null);
  const salvando = useRef(false);

  useEffect(() => {
    function verificarSaida(evento) {
      if (
        modoReal &&
        (
          salvando.current ||
          Object.keys(pendentes.current).length > 0
        )
      ) {
        evento.preventDefault();
        evento.returnValue = "";
      }
    }

    window.addEventListener("beforeunload", verificarSaida);

    return () => {
      window.removeEventListener("beforeunload", verificarSaida);
    };
  }, [modoReal]);

  async function salvarPendentes() {
    if (!modoReal || salvando.current) return;

    salvando.current = true;
    setEstadoSalvamento("Salvando...");

    try {
      while (Object.keys(pendentes.current).length > 0) {
        const [campo, valor] = Object.entries(pendentes.current)[0];

        const resposta = await fetch(
          `/api/patin/documento/${encodeURIComponent(protocolo)}/campo`,
          {
            method: "PATCH",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ campo, valor })
          }
        );

        if (!resposta.ok) {
          throw new Error("Não foi possível salvar a resposta.");
        }

        if (pendentes.current[campo] === valor) {
          delete pendentes.current[campo];
        }
      }

      setEstadoSalvamento("Salvo");
      setErro("");
    } catch (e) {
      setEstadoSalvamento("Erro ao salvar. Nova tentativa em 5 segundos.");
      setErro(e.message);

      if (temporizador.current) {
        clearTimeout(temporizador.current);
      }

      temporizador.current = setTimeout(() => {
        if (Object.keys(pendentes.current).length > 0) {
          salvarPendentes();
        }
      }, 5000);
    } finally {
      salvando.current = false;
    }
  }

  function atualizar(id, valor) {
    setRespostas((anterior) => ({
      ...anterior,
      [id]: valor
    }));

    if (!modoReal) return;

    pendentes.current[id] = valor;
    setEstadoSalvamento("Alterações pendentes");

    if (temporizador.current) {
      clearTimeout(temporizador.current);
    }

    temporizador.current = setTimeout(() => {
      salvarPendentes();
    }, 900);
  }

  const [navegando, setNavegando] = useState(false);

  async function aguardarSalvamento() {
    if (!modoReal) return true;

    if (temporizador.current) {
      clearTimeout(temporizador.current);
    }

    const limite = Date.now() + 15000;

    while (salvando.current && Date.now() < limite) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }

    if (salvando.current) {
      setErro("O salvamento está demorando. Tente novamente.");
      return false;
    }

    if (Object.keys(pendentes.current).length > 0) {
      await salvarPendentes();
    }

    return (
      !salvando.current &&
      Object.keys(pendentes.current).length === 0
    );
  }

  async function avancar() {
    if (navegando) return;
    setNavegando(true);

    try {
      const salvo = await aguardarSalvamento();

      if (!salvo) return;

      if (etapa < etapas.length - 1) {
        setEtapa((atual) => atual + 1);
      } else {
        setConcluido(true);
      }

      window.scrollTo(0, 0);
    } finally {
      setNavegando(false);
    }
  }

  async function voltar() {
    if (navegando) return;
    setNavegando(true);

    try {
      const salvo = await aguardarSalvamento();

      if (!salvo) return;

      if (etapa > 0) {
        setEtapa((atual) => atual - 1);
        window.scrollTo(0, 0);
      }
    } finally {
      setNavegando(false);
    }
  }

  return (
    <main className="patin-formulario">
      <header className="patin-form-header">
        <Link to="/patin" className="patin-form-voltar">
          <ArrowLeft size={18} />
          PATIN Digital
        </Link>

        <span>Nunca Foi Só Batom</span>
      </header>

      <div className="patin-form-container">
        {modoReal && (
          <div
            style={{
              background: "#fff",
              padding: "16px 20px",
              borderRadius: "12px",
              marginBottom: "20px"
            }}
          >
            <strong>
              PATIN de {participante?.nome || "Participante"}
            </strong>

            <p>Protocolo: {protocolo}</p>

            <p aria-live="polite">
              {estadoSalvamento || "Documento carregado"}
            </p>

            {erro && (
              <p role="alert" style={{ color: "#a12222" }}>
                {erro}
              </p>
            )}
          </div>
        )}
        {concluido ? (
          <section className="patin-form-card patin-form-concluido">
            <CheckCircle2 size={58} />

            {modoReal ? (
              <>
                <h1>Você chegou à última etapa do PATIN!</h1>

                <p>
                  Suas respostas foram salvas e permanecem disponíveis
                  para consulta e atualização. O preenchimento das etapas
                  não significa que o acompanhamento foi encerrado.
                  Você poderá continuar desenvolvendo seu plano junto
                  à consultora responsável.
                </p>

                <Link
                  to="/patin/meu-plano"
                  className="patin-form-botao"
                >
                  Voltar ao Meu PATIN
                </Link>
              </>
            ) : (
              <>
                <h1>Você chegou ao final da demonstração!</h1>

                <p>
                  Você percorreu as etapas do PATIN Digital.
                  Nesta versão de demonstração, suas respostas
                  não foram enviadas nem salvas.
                </p>

                <Link to="/patin" className="patin-form-botao">
                  Voltar ao início
                </Link>
              </>
            )}
          </section>
        ) : (
          <>
            <div className="patin-form-progresso">
              <div className="patin-form-progresso-texto">
                <span>
                  Etapa {etapa + 1} de {etapas.length}
                </span>
                <strong>{progresso}%</strong>
              </div>

              <div className="patin-form-barra">
                <div style={{ width: `${progresso}%` }} />
              </div>
            </div>

            <section className="patin-form-card">
              <span className="patin-form-etiqueta">
                MEU PLANO DE TRANSFORMAÇÃO
              </span>

              <h1>{etapaAtual.titulo}</h1>

              <p className="patin-form-descricao">
                {etapaAtual.descricao}
              </p>

              <div className="patin-form-campos">
                {etapaAtual.campos.map((campo) => (
                  <Campo
                    key={campo[0]}
                    campo={campo}
                    valor={respostas[campo[0]]}
                    atualizar={atualizar}
                  />
                ))}
              </div>

              <div className="patin-form-navegacao">
                <button
                  type="button"
                  className="patin-form-anterior"
                  onClick={voltar}
                  disabled={etapa === 0}
                >
                  <ArrowLeft size={18} />
                  Anterior
                </button>

                <button
                  type="button"
                  className="patin-form-botao"
                  onClick={avancar}
                >
                  {etapa === etapas.length - 1
                    ? "Finalizar demonstração"
                    : "Próxima etapa"}
                  <ArrowRight size={18} />
                </button>
              </div>
            </section>

            <div className="patin-form-aviso">
              <LockKeyhole size={17} />
              <span>
                Versão de demonstração. As respostas ficam
                apenas nesta tela e serão perdidas ao sair.
              </span>
            </div>
          </>
        )}
      </div>
    </main>
  );
}
